import u1 from '../../assets/images/dashboard/boy-2.png'
import u2 from '../../assets/images/user/4.jpg'
import u3 from '../../assets/images/user/1.jpg'
import u4 from '../../assets/images/user/5.jpg'
import u5 from '../../assets/images/user/6.jpg'
import u6 from '../../assets/images/user/7.jpg'

export const clients = [
  {
    imagepath: u1,
    title: "Nick Stone",
    position: "Developer",
    desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia"
  },
  {
    imagepath: u1,
    title: "Poio klot",
    position: "Designer",
    desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia"
  },
  {
    imagepath: u1,
    title: "Scarlett john",
    position: "ceo",
    desc: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia"
  }
]

export const cartProducts = [
    {
      details: "Simply dummy text of the printing",
      qty: "1",
      status: "pending",
      statusColor:"primary",
      price: "6523",
      className: "pill-badge-secondary"
    },
    {
      details: "Long established",
      qty: "5",
      status: "cancle",
      statusColor:"secondary",
      price: "6565",
      className: "pill-badge-success"
    },
    {
      details: "sometimes by accident",
      qty: "10",
      status: "cancle",
      statusColor:"primary",
      price: "9361",
      className: "pill-badge-warning"
    },
    {
      details: "Classical Latin literature",
      qty: "9",
      status: "return",
      statusColor:"primary",
      price: "2658",
      className: "pill-badge-primary"
    },
    {
      details: "keep the site on the Internet",
      qty: "8",
      status: "pending",
      statusColor:"primary",
      price: "6328",
      className: "pill-badge-secondary"
    },
    {
      details: "Molestiae consequatur",
      qty: "3",
      status: "cancle",
      statusColor:"secondary",
      price: "4852",
      className: "pill-badge-info"
    },
    {
      details: "Pain can procure",
      qty: "8",
      status: "return",
      statusColor:"primary",
      price: "3589",
      className: "pill-badge-primary"
    }
]

export const  employeeStatus= [
    {
      imagepath: u2,
      title: "John Deo",
      online: "14+ online",
      position: "Designer",
      skill: "30%",
      exp: "2 year",
      classname: "primary"
    },
    {
      imagepath: u3,
      title: "Holio Mako",
      online: "250+ online",
      position: "Developer",
      skill: "70%",
      exp: "3 year",
      classname: "secondary"
    },
    {
      imagepath: u4,
      title: "Mohsib lara",
      online: "99+ online",
      position: "tester",
      skill: "60%",
      exp: "5 month",
      classname: "primary"
    },
    {
      imagepath: u5,
      title: "Hileri Soli",
      online: "150+ online",
      position: "Designer",
      skill: "25%",
      exp: "3 month",
      classname: "secondary"
    },
    {
      imagepath: u6,
      title: "Pusiz bia",
      online: "19+ online",
      position: "Developer",
      skill: "90%",
      exp: "5 year",
      classname: "primary"
    }
  ]